import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import {
  withLocation,
} from "CommonCore/router-util";
import store from "CommonState/store";
import moment from "moment";

import {
  EditPanel,
  Spinner,
  Tooltip,
} from "CommonComponents/bricks";
import {
  VERTRAGSARTEN_LEHRAUFTRAG,
} from "../constants";
import apifetch from "CommonCore/apifetch";

import Breadcrumb from "CommonComponents/breadcrumb";
import ReportBase, {
  exportReport,
} from "./report-base";
import {
  formatKonto,
} from "Apis/massnahme-api";
import {
  formatMoney2,
  formatNumber,
  LocaleMoneyFormat,
} from "CommonCore/l10n";

@store("k_einrichtungLookup")
export default class ReportLehraufträgeFK extends ReportBase {
  constructor() {
    super();
    this.rows = {};
    this.state = { rows: [], headers: [], updateId: 0 };

    this.criteria = { jahr: String(moment().year()), semester: "04-01", fakultaet: null };
  }

  storeTable = table => {
    this.rows = table;
  };
  storeHeaders = headers => {
    this.headers = headers;
  };

  componentDidMount() {
    // this.onUpdate();
  }

  render() {
    const { inflight, filtered } = this.state;
    const { k_einrichtungLookup } = this.props;

    const jahr = moment().year();

    const schema = {
      table: [
        {
          field: "semester",
          display: "Semester",
          type: "select",
          choices: [{ label: "Sommer", value: "04-01" }, { label: "Winter", value: "10-01" }],
        },
        {
          field: "jahr",
          display: "Jahr",
          type: "select",
          choices: _.range(jahr - 5, jahr + 5).map(x => {
            return { label: x.toString(), value: x.toString() };
          }),
        },
        {
          field: "fakultaet",
          display: "Fakultät",
          type: "select",
          choices: k_einrichtungLookup && _.map(_.filter(k_einrichtungLookup, e => e.e_typkuerzel == "FK" || ["Z5000", "Z2000", "I0000"].includes(e.e_kostenstelle)), e => {
            return { label: e.e_kbez, value: e.e_id };
          }),
        },

      ],
    };

    return <Container fluid>
      <Row>
        <Col xs={6}>
          <EditPanel
            editable
            defaultEditable
            entity={this.criteria}
            header={<h4 key='h4'>Kriterien</h4>}
            schema={schema}
            submitText='Auswertung starten'
            onSave={this.onUpdate}
            onChange={this.onChange}
            disableSubmit={!this.criteria.fakultaet || !this.criteria.jahr || !this.criteria.semester}
            noToggleOnSave
            hideCancel
          />
        </Col>
      </Row>
      {filtered && <div style={{ marginTop: "6px", marginBottom: "6px" }}>
        <ButtonToolbar className='align-right'>
          <Button className='float-end' disabled={_.isEmpty(filtered)} style={{ marginLeft: "1em" }} onClick={this.exportData}>
            <Tooltip overlay='Daten als XLSX exportieren'>Exportieren {!_.isEmpty(filtered) ? `(Anzahl ${ filtered.length })` : ""}</Tooltip></Button>
        </ButtonToolbar>

      </div>}


      <Breadcrumb name='Auswertung Lehraufträge FK' route='/auswertung/lehraufträge_fk' />

      {inflight && <Spinner />}

      {!inflight && filtered &&

        <ReportLehraufträgeFKTable
          {...this.props}
          data={filtered}
          updateId={this.state.updateId}
          onTableUpdated={this.storeTable}
          onHeadersUpdated={this.storeHeaders}
        />
      }
    </Container>;
  }

  onChange = change => {
    const { criteria } = this;
    _.assign(criteria, change);
    this.setState({ criteria: _.clone(criteria) });
  };

  onUpdate = () => {
    const { updateId } = this.state;
    const { criteria } = this;

    this.setState({ inflight: true }, async() => {
      // Backend alles filtern lassen, was es kann
      const url = `/api/shkantrag/auswertung/lehrauftrag?abgeschlossen=1&artid=${ VERTRAGSARTEN_LEHRAUFTRAG[0] }`;
      const list = await apifetch(url);

      // Frontend den Rest filtern lassen

      const filtered = _.filter(list.data, antrag => antrag.a_fakultaet_eid == criteria.fakultaet
        && _.some(antrag.massnahmen, m => {
          return m.m_gueltigab == `${ criteria.jahr }-${ criteria.semester }`;
        }));


      this.setState({ filtered, inflight: false, updateId: updateId + 1 });
    });
  };

  exportData = () => {
    // Export starten
    exportReport(this.rows, _.map(this.headers, x => x.text));
  };
}

@withLocation
@store("k_anredeLookup", "k_finanzamtLookup", "k_einrichtungLookup")
class ReportLehraufträgeFKTable extends Component {
  constructor() {
    super();
    this.state = {};
  }

  getHeaderList = () => {
    // Header-Texte liefern (hier statisch, kann aber in anderen Report dynamisch sein)
    return [
      { text: "lfd. Nr" }
      , { text: "Lehreinheit" }
      , { text: "VA Art" }
      , { text: "VA Typ" }
      , { text: "VA Typ-Nr. gemäß MKW-Liste" }
      , { text: "Bezeichnung des LA" }
      , { text: "SVA-Nr. (PFI)" }
      , { text: "PBP-ID" }
      , { text: "KSK ja / nein" }
      , { text: "Name" }
      , { text: "Vorname" }
      , { text: "SWS" }
      , { text: "LVS" }
      , { text: "Std. Verg.", format: LocaleMoneyFormat }
      , { text: "Lehrkosten", format: LocaleMoneyFormat }
      , { text: "FK", format: LocaleMoneyFormat }
      , { text: "Gesamtkosten", format: LocaleMoneyFormat }
      , { text: "FA" } // leer lassen
      , { text: "Kostenstelle" }
      , { text: "Endabrechnung" } // leer lassen
      , { text: "Minderausgabe" }// leer lassen
      , { text: "geh. Std." }// leer lassen
      , { text: "Rückstellungen auflösen ja/nein" }// leer lassen
      , { text: "Bemerkungen" }, // leer lassen
    ];
  };

  render() {
    const { data, inflight, k_anredeLookup, k_finanzamtLookup } = this.props;

    if (!k_anredeLookup || !k_finanzamtLookup) {
      return null;
    }

    this.rows = data;

    const headers = this.getHeaderList();
    this.props.onHeadersUpdated && this.props.onHeadersUpdated(headers); // Headers an Parent melden

    const tableContent = this.renderRows(this.rows, headers);
    this.props.onTableUpdated && this.props.onTableUpdated(tableContent); // Daten an Parent melden

    return <div>
      <Table size='sm' bordered hover>
        <thead>
          <tr style={{ backgroundColor: "#ddd" }}>
            {_.map(headers, (item, i) => <th key={"header-" + i} className='delineated-header'>{item.text}</th>)}
          </tr>
        </thead>
        <tbody>
          {!inflight && tableContent}


        </tbody>
      </Table>
      {_.isEmpty(this.rows) && <h3>Keine Daten</h3>}
      {inflight && <Spinner />}
    </div>;
  }

  renderRows(data, header) {
    // -- Daten in Tabellenform ausgeben'
    const { k_anredeLookup, k_finanzamtLookup, k_einrichtungLookup } = this.props;

    if (!k_anredeLookup || !k_finanzamtLookup || !k_einrichtungLookup) {
      return null;
    }

    let pos = 0;
    const rows = _.flatMap(data, antrag => {
      let newrows = [];
      const p = antrag.antrag_person[0];

      newrows = _.flatMap(antrag.massnahmen, m => {
        pos++;

        const lehrkosten = m.ml_gesamtstd * m.ml_stundensatz;
        const gesamtkosten = lehrkosten + m.ml_fahrtkosten;
        const va_arten = { Fakultativ: "w", Obligatorisch: "p", Wahlobligatorisch: "wp" };

        return _.map(m.massnahmefinanz, (mf, index) => {
          const anteilLehrkosten = lehrkosten / 100 * mf.mfi_prozent;

          const fields = [
            index == 0 ? pos : "" // Lfdnr
            , index == 0 ? m.ml_lehreinheit : "" // Lehreinheit
            , index == 0 ? va_arten[m.ml_veranstaltungstyp] : "" // 'VA Art'
            , index == 0 ? m.ml_veranstaltungsart : "" // 'VA Typ' -- Die Felder sind falsch herum benannt!
            , index == 0 ? m.ml_veranstaltungstypnr : "" // 'VA-Typ-Nr.'
            , index == 0 ? m.ml_bezeichnung : "" // 'Bezeichnung des LA'
            , p.ap_svapfi // 'SVA-Nr. (PFI)'
            , index == 0 ? m.m_pbpid : "" // 'PBP-ID'
            , m.ml_istkuenstlerisch ? "Ja" : "Nein"
            , p.ap_name // Name
            , p.ap_vorname // 'Vorname'
            , formatNumber(m?.ml_sws) // 'SWS'
            , m.ml_gesamtstd // 'LVS'
            , index == 0 ? formatMoney2(m?.ml_stundensatz) : "" // 'Std. Verg.'
            , formatMoney2(anteilLehrkosten) // 'Lehrkosten'
            , index == 0 ? formatMoney2(m?.ml_fahrtkosten) : "" // 'FK'
            , index == 0 ? formatMoney2(gesamtkosten) : "" // 'Gesamtkosten'
            , mf.mfi_fanr // 'FA'
            , formatKonto({ kostenstelle: mf.mfi_kostenstelle, budgetkonto: mf.mfi_budgetkonto })// _'Kostenstelle'
            , ""// 'Endabrechnung' // leer lassen
            , ""// 'Minderausgabe'// leer lassen
            , ""// 'geh. Std.'// leer lassen
            , ""// 'Rückstellungen auflösen J/N'// leer lassen
            , "", // 'Bemerkungen'// leer lassen
          ];
          return <tr>{_.map(fields, (f, idx) => <td className={`${ header[idx].format ? "align-right" : "" }`}>{f}</td>)}</tr>;
        });
      });
      return newrows;
    });

    return rows;
  }
}


